function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;
export { _stackGet as _ };